import { render, staticRenderFns } from "./onlineAppointments.vue?vue&type=template&id=2bbad4a8&"
import script from "./onlineAppointments.vue?vue&type=script&lang=js&"
export * from "./onlineAppointments.vue?vue&type=script&lang=js&"
import style0 from "./onlineAppointments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports